import React from 'react';
import { Box, Heading } from 'bumbag';

import { TRANSACTION_ACTIONS } from '../constants';
const ICON_CLASSNAMES = {
  [TRANSACTION_ACTIONS.APPROVED]: 'far fa-check-circle',
  [TRANSACTION_ACTIONS.FAILURE]: 'far fa-ban',
  [TRANSACTION_ACTIONS.REJECTED]: 'far fa-ban',
};
const TEXT_CLASSNAMES = {
  [TRANSACTION_ACTIONS.APPROVED]: 'success',
  [TRANSACTION_ACTIONS.FAILURE]: 'primary',
  [TRANSACTION_ACTIONS.REJECTED]: 'primary',
};

// @ts-expect-error TS(7031): Binding element 'type' implicitly has an 'any' typ... Remove this comment to see the full error message
function getText({ type }) {
  if (type === TRANSACTION_ACTIONS.APPROVED) {
    return `Your payment has been approved.`;
  }

  if (type === TRANSACTION_ACTIONS.FAILURE) {
    return `Your payment failed.`;
  }

  if (type === TRANSACTION_ACTIONS.REJECTED) {
    return `Your payment has been rejected.`;
  }

  return;
}

type Props = {
  className?: string;
  defaultIsActive?: boolean;
  // @ts-expect-error TS(2503): Cannot find namespace 'TRANSACTION_ACTIONS'.
  type: TRANSACTION_ACTIONS.APPROVED | TRANSACTION_ACTIONS.FAILURE | TRANSACTION_ACTIONS.REJECTED;
};
type State = {};
export default class CompletedTransactionMessage extends React.Component<Props, State> {
  static defaultProps = {
    className: undefined,
    defaultIsActive: true,
  };
  state = {};
  render = () => {
    const { className, defaultIsActive, type, ...props } = this.props;

    if (!defaultIsActive) {
      return null;
    }

    return (
      <Box className={className} textAlign="center" {...props}>
        <Heading use="h6" color={TEXT_CLASSNAMES[type]}>
          <i className={ICON_CLASSNAMES[type]} />{' '}
          {getText({
            type,
          })}
        </Heading>
      </Box>
    );
  };
}
